module.exports = __webpack_public_path__ + "static/dashboard_donate_bgM@2x-586cab07923870ae16b01526aab62478.png";